import React from 'react';
import { Link } from 'gatsby';

import '../../styles/collections/media-bar.scss';

const MediaBar = (props) => {
  const mediaContexts = ['All', 'Images', 'Books', 'Film', 'Audio'];

  return (
    <div className="collections-media-bar">
      <div className="collections-media-bar__tabs">
        <div className="collections-media-bar__tab-label">
          <span className="hide-small-viewports">Browsing by</span> Medium
        </div>
        {mediaContexts.map(medium => (
          <>
            {(props.mediaContext === medium) ? (
              <button
                className="collections-media-bar__tab selected"
                onClick={() => props.handleTabClick(medium)}
              >
                {medium}
              </button>
            ) : (
              <Link
                className="collections-media-bar__tab"
                to={`/collections/${medium.toLowerCase()}`}
              >
                {medium}
              </Link>
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export default MediaBar;